export const ROLE_LIST_POST = '/role/list';
export const ADD_ROLE_POST = '/role/add ';
export const UPDATE_ROLE_POST = "role/update";
export const DELETE_ROLE = 'role/delete';
export const EDIT_ROLE_GET = '/role/edit';
export const ROLE_CREATE_GET = '/role/create';
